/** 運行キャリア名を表示しない、キャリアコード */
export const airlineCodeNoDisplayAirline = ['OC'];

/** 深夜発の表示を行う必要がある言語 */
export const LateNightDepartureDisplayLanguage = ['ja', 'cn', 'ko'];
